import React, { useState, useEffect, useRef } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase"; // Adjust if your path differs

export default function ResetPasswordPage({ onBack }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const emailRef = useRef(null);

  useEffect(() => {
    // Autofocus email field
    if (emailRef.current) {
      emailRef.current.focus();
    }

    // Clean up leftover overlays from old modals
    const leftovers = document.querySelectorAll(".modal, .overlay, .backdrop");
    leftovers.forEach((el) => el.remove());
  }, []);

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await sendPasswordResetEmail(auth, email, {
        url: "https://dat-gpt.web.app/auth/reset", // or your Azure URL
        handleCodeInApp: true,
      });

      setMessage(
        "If this email exists, a password reset link has been sent. Please check your inbox (and spam)."
      );
      setEmail("");
    } catch (err) {
      console.error("Reset error:", err.code, err.message);
      const map = {
        "auth/invalid-email": "Please enter a valid email address.",
        "auth/too-many-requests":
          "Too many attempts. Please wait a few minutes and try again.",
      };
      setMessage(map[err.code] || "Unable to send reset email right now.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 text-white py-12 px-4 flex flex-col items-center justify-center relative z-[60] pointer-events-auto">
      <div className="bg-gray-800 text-white rounded-2xl shadow-2xl p-8 max-w-sm w-full relative z-[70] pointer-events-auto">
        <button
          className="absolute top-2 right-3 text-xl text-gray-400 hover:text-gray-700"
          onClick={onBack}
        >
          &times;
        </button>
        <h2 className="text-lg font-bold mb-4 text-gray-900">Reset Password</h2>
        <form onSubmit={handleReset} className="space-y-4">
          <input
            ref={emailRef}
            className="w-full bg-gray-900 text-white border border-gray-600 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            type="email"
            placeholder="Your email address"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 hover:bg-indigo-500 text-white py-2 rounded font-semibold transition"
          >
            {loading ? "Sending..." : "Send reset link"}
          </button>
        </form>
        {message && (
          <div className="mt-4 text-center text-sm text-indigo-700">
            {message}
          </div>
        )}
        <button
          onClick={onBack}
          className="mt-6 underline text-blue-400 hover:text-blue-300 text-xs block text-center"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}
